import { TransportCoverDualIcon, TransportCoverDualOpenIcon, TransportCoverIcon, TransportCoverOpenIcon } from 'app/icons';
import React from 'react';

import { COLOR_CLASSES } from '../TabPanelCondition.constants';
import { GuardState } from '../TabPanelCondition.types';

export const CoverIcon = ({ hasDualCover, isOpen, position, guardStatus, guardOut, guardOutBit, disabled = false, config }) => {
  const viewBox = hasDualCover ? '0 0 64 64' : '0 0 64 64';

  // Если нет данных - показываем disabled иконку
  if (disabled) {
    const Icon = hasDualCover ? TransportCoverDualIcon : TransportCoverIcon;
    return <Icon viewBox={viewBox} disabled />;
  }

  // Если guard_status не дефолтное
  if (guardStatus !== config.conditions.guard_status.default) {
    return hasDualCover ? (
      <DualCoverIconByGuardStatus
        guardStatus={guardStatus}
        guardOut={guardOut}
        guardOutBit={guardOutBit}
        isOpen={isOpen}
        position={position}
        viewBox={viewBox}
        config={config}
      />
    ) : (
      <SingleCoverIconByGuardStatus
        guardStatus={guardStatus}
        guardOut={guardOut}
        guardOutBit={guardOutBit}
        isOpen={isOpen}
        viewBox={viewBox}
        config={config}
      />
    );
  }

  // Дефолтное состояние
  const Icon = hasDualCover ? TransportCoverDualIcon : TransportCoverIcon;
  return <Icon viewBox={viewBox} disabled />;
};

// Двойная крышка в зависимости от guard_status
const DualCoverIconByGuardStatus = ({ guardStatus, guardOut, guardOutBit, isOpen, position, viewBox, config }) => {
  // guard_status[2] === '0' - обычное состояние
  if (guardStatus === GuardState.UNLOCKED) {
    if (isOpen) {
      return <TransportCoverDualOpenIcon viewBox={viewBox} className={COLOR_CLASSES.INHERIT} position={position} />;
    }
    return <TransportCoverDualIcon viewBox={viewBox} className={COLOR_CLASSES.INHERIT} />;
  }

  // guard_status[2] === '1' - тревога
  if (guardOut !== config.conditions.guard_out.default) {
    const colorClass = guardOutBit === GuardState.UNLOCKED ? COLOR_CLASSES.PRIMARY : COLOR_CLASSES.ERROR;

    return <TransportCoverDualOpenIcon viewBox={viewBox} className={colorClass} />;
  }

  return <TransportCoverDualOpenIcon viewBox={viewBox} className={COLOR_CLASSES.INHERIT} />;
};

// Одиночная крышка в зависимости от guard_status
const SingleCoverIconByGuardStatus = ({ guardStatus, guardOut, guardOutBit, isOpen, viewBox, config }) => {
  // guard_status[2] === '0' - обычное состояние
  if (guardStatus === GuardState.UNLOCKED) {
    const Icon = isOpen ? TransportCoverOpenIcon : TransportCoverIcon;
    return <Icon viewBox={viewBox} className={COLOR_CLASSES.INHERIT} />;
  }

  // guard_status[2] === '1' - тревога
  if (guardOut !== config.conditions.guard_out.default) {
    const colorClass = guardOutBit === GuardState.UNLOCKED ? COLOR_CLASSES.PRIMARY : COLOR_CLASSES.ERROR;

    return <TransportCoverOpenIcon viewBox={viewBox} className={colorClass} />;
  }

  return <TransportCoverOpenIcon viewBox={viewBox} className={COLOR_CLASSES.INHERIT} />;
};
